import type { LucideIcon, LucideProps } from 'lucide-react';
import { cx } from './cx';

/** A lucide icon drawn like the boards' `.ico` (16 px, stroke 1.8); `size="s"` 13 px, `"l"` 20 px. */
export function Icon({
  as: As,
  size,
  className,
  ...rest
}: { as: LucideIcon; size?: 's' | 'l' } & Omit<LucideProps, 'size'>) {
  return <As aria-hidden="true" className={cx('ico', size, className)} strokeWidth={1.8} {...rest} />;
}
